<template>
<div id="solidBackground" :style="{ position: position, height: `${height}px` }">
    <div v-scroll="onScroll" :style="{
        transform: `rotate(${rotate}deg)`,
        top: animDone ? `${top}vh` : `${top}px`,
        left: `-${left}%`,
        height: `${height}px`,
        transitionDuration: `${animTime.present}s`,
      }"></div>
</div>
</template>

<script>
export default {
    data() {
        return {
            rotate: 5,
            height: 0,
            width: 0,
            position: "absolute",
            top: 0, // Zmieniono z 88 na 0 (będzie nadpisane przez calculateHomePosition)
            left: 50,
            animDone: false,
            animTime: {
                present: 0,
                in: 3,
                out: 1.5,
            },
        };
    },
    methods: {
        calculateHomePosition() {
            // Jeśli animacja jest zakończona (jesteśmy na dole) lub to mobile, nie przeliczaj
            if (this.animDone) return;

            const h = window.innerHeight;
            const w = window.innerWidth;
            const elementWidth = this.$isMobile ? 1000 : 8000; // Stała szerokość z CSS w scoped (div wewnątrz)

            // Konwersja stopni na radiany
            const angleRad = this.rotate * (Math.PI / 180);

            // Obliczenia geometryczne, aby prawy koniec linii celował w (Height - 10px)
            // PivotX to środek elementu względem lewej krawędzi ekranu.
            // Element startuje na -50% szerokości rodzica (100vw), czyli -0.5*w.
            // Środek elementu 8000px jest przesunięty o +4000px.
            // const pivotX = -0.5 * w + (elementWidth / 2);

            // Docelowy punkt przecięcia (Prawa krawędź ekranu, Dół ekranu - 10px)
            // Formuła uwzględnia, że transform-origin jest w środku elementu (50% 50%),
            // a 'top' pozycjonuje górną krawędź nieobróconego pudełka.
            // Korekta o (1 - cos) wynika z faktu, że obrót następuje wokół środka wysokości elementu,
            // ale my pozycjonujemy krawędź górną.

            // Uproszczona formuła liniowa dla górnej krawędzi:
            // Y_target = Top + (PivotX - ScreenRight) * tan(angle)
            // (Z uwzględnieniem kierunku osi Y w CSS i obrotu clockwise)
            const space = this.$isMobile ? h-( h * 1.1) : ( h *  0.1);

            const targetY = h - space;
            const distFromPivotToRightEdge = 1.5 * w - (elementWidth / 2); // (w - pivotX)

            // Wyliczamy wymagany 'top'
            // Odejmujemy małą korektę wynikającą z grubości/obrotu (opcjonalne, ale precyzyjniejsze)
            // Dla małych kątów (5deg) i pozycji 'top' prostsze przybliżenie:
            this.top = targetY - (distFromPivotToRightEdge * Math.tan(angleRad));
            this.rotate = 5;
            this.left = 50;
                if (this.$isMobile) {
            this.left = 100;
  
                    } else {
            this.left = 50;
                    }
        },
        onScroll(e) {
            if (typeof window === "undefined" ) return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            if (top > window.innerHeight / 3) {
                if (this.animDone) return;
                this.animDone = true;
                this.rotate = 0;
                this.top = 0 // vh
                this.animTime.present = this.animTime.in;
       
            } else {
                if (!this.animDone) return;
                this.animDone = false;
             
          if (!this.animDone) {
                             this.calculateHomePosition();
                    }
            }
        },
        onResize() {
            if (!this.animDone) {
                this.calculateHomePosition();
            }
        }
    },
    mounted() {
        this.height = document.body.scrollHeight;
        this.width = screen.width;

        // Wyliczamy pozycję startową
        this.calculateHomePosition();
        window.addEventListener('resize', this.onResize);

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
};
</script>

<style lang="scss" scoped>
#solidBackground {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100vw;
    height: 200vh;
    position: absolute;

    div {
        background: #002a6b;
        width: 8000px;
        height: 2000px;
        position: absolute;
        transform: rotate(3deg);
        /* Top jest sterowany dynamicznie przez JS */
        left: -50%;
        overflow: hidden;
        opacity: 0.82;
        transition: all cubic-bezier(0.46, 0.02, 0.21, 0.98);
    }
}
</style>